var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
      _vm.nomenclature &&
      _vm.nomenclature.unit_of_measurement &&
      _vm.nomenclature.unit_of_measurement.name
    )?_c('span',[_vm._v(" "+_vm._s(_vm.$t( "goods.units_of_measurements." + _vm.nomenclature.unit_of_measurement.name + ".short" ))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }